export function formatDate(date: string) {
  try {
    const dateSplit = date.split('-')
    return `${dateSplit.at(2)}/${dateSplit.at(1)}/${dateSplit.at(0)}`
  } catch (error) {
    return 'Invalid date'
  }
}

export function parseBrazilianDate(dateStr: string): Date | null {
  if (!dateStr) return null
  const [datePart, timePart] = dateStr.split(" às ")
  if (!datePart || !timePart) return null

  const [day, month, year] = datePart.split("/").map(Number)
  const [hour, minute, second] = timePart.split(":").map(Number)

  return new Date(year, month - 1, day, hour, minute, second)
}